module.exports = __webpack_public_path__ + "static/media/3 11 Tulleord Peano er feil.257c9e22.mp3";